import { render, staticRenderFns } from "./phcourses.vue?vue&type=template&id=44aabce0&scoped=true"
import script from "./phcourses.vue?vue&type=script&lang=js"
export * from "./phcourses.vue?vue&type=script&lang=js"
import style0 from "./phcourses.vue?vue&type=style&index=0&id=44aabce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aabce0",
  null
  
)

export default component.exports